import { HttpRequest } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { Router } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';
import { Subject } from 'rxjs';
import { DefaultConfig } from 'src/assets/default.config';
import { E2EData } from './e2e-data';

export function initializeKeycloak(
  keycloak: KeycloakService,
  router: Router
) {
  const pathname = window.location.pathname;
  const isDisclaimerPage = DefaultConfig.keycloak.disclaimerPagePath === pathname || pathname.startsWith(DefaultConfig.keycloak.disclaimerPagePath);

  let checkLoginIframe = true;
  if (window.location.hostname !== (new URL(DefaultConfig.keycloak.url)).hostname) {
    checkLoginIframe = false;
  }

  // In e2e tests, skip the login iframe check and the login mask by using e2e tokens

  const e2eData = new E2EData(window);
  let token: string | undefined;
  let refreshToken: string | undefined;
  if (e2eData.isSet) {
    checkLoginIframe = false;
    token = e2eData.token;
    refreshToken = e2eData.refreshToken;
  }

  return () => {
    const aiDisclaimerApproved = localStorage.getItem('aiDisclaimerApproved');
    if (!aiDisclaimerApproved && router.url !== DefaultConfig.keycloak.disclaimerPagePath) {
      return router.navigateByUrl(DefaultConfig.keycloak.disclaimerPagePath);
    }

    return keycloak.init({
      config: DefaultConfig.keycloak,
      initOptions: {
        onLoad: isDisclaimerPage ? 'check-sso' : 'login-required',
        checkLoginIframe,
        token,
        refreshToken,
      },
      // only add the token to requests to our API backend
      shouldAddToken: (req: HttpRequest<unknown>): boolean => {
        const { url } = req;
        const isAcceptablePath = url.startsWith(DefaultConfig.baseApi);
        return isAcceptablePath;
      }
    });
  };
}

// Easy fix for the service not having
// a Keycloak instance initialized,
// which otherwise would result in a
// access-on-undefined-error
export const KeycloakServiceMock = {
  isUserInRole: (_: any) => true,
  login: (_: any) => true,
  isLoggedIn: (_: any) => true,
  logout: (_: any) => true,
  getToken: (_: any) => '',
  updateToken: (_: any) => Promise.resolve(),
  init: (_: any) => true,
  loadUserProfile: (_: any) => new Promise(() => undefined),
  getKeycloakInstance: (_: any) => ({ subject: 'xy' }),
  keycloakEvents$: new Subject(),
};

@NgModule({
  declarations: [],
  providers: [
    {
      provide: KeycloakService,
      useValue: KeycloakServiceMock
    }
  ]
})
export class KeycloakMockModule { }
